import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p, selectObjects } from "~/misc/common";

export default class extends Controller {
	connect() {
		console.log('initTripsForm');

		const trips = $('#toJs').data('trips');

		$('#recent_recent').change(function () {
			const trip = selectObjects(trips, 'id', $('#recent_recent').myGetNumValue())[0];
			p(trip);
			if (trip) {
				$('#trip_o_name').val(trip.o_name);
				$('#trip_o_address').val(trip.o_address);
				$('#trip_d_name').val(trip.d_name);
				$('#trip_d_address').val(trip.d_address);
				$('#trip_description').val(trip.description);
				$('#trip_distance').val(trip.distance);
			}
		});
	}
}
